import { useEffect } from 'react';

/**
 * Subscribe to a PubNub CustomEvent dispatched by pubnub-service.
 *
 * @param pnmType  The message type to listen for (e.g. 'callCardUpdate').
 *                 The listener is attached to `window` for `pubnub:<pnmType>`.
 * @param handler  Callback receiving the event detail (the PubNub message payload).
 *
 * @example
 *   usePubNubEvent('callCardUpdate', (data) => {
 *     console.log('Call card updated:', data.callCardId);
 *   });
 */
export function usePubNubEvent(
  pnmType: string,
  handler: (detail: any) => void,
): void {
  useEffect(() => {
    const eventName = `pubnub:${pnmType}`;
    const listener = (e: Event) => {
      handler((e as CustomEvent).detail);
    };

    window.addEventListener(eventName, listener);
    return () => window.removeEventListener(eventName, listener);
  }, [pnmType, handler]);
}
